import React from 'react';
import { ModalBody, ModalHeader } from 'baseui/modal';
import CustomModal from 'presentation/components/modal/CustomModal';
import CustomModalFooter from 'presentation/components/modal/CustomModalFooter';
import { Col, Container, Row } from 'react-bootstrap';
import { Button } from '@techem/ui-components';
import { SIZE } from 'baseui/button';
import { TrackerUtil } from 'tracking/TrackerUtil';
import CustomerPortalModalContent from 'presentation/components/shared/CustomerPortalModalContent';
import { useStyletron } from 'baseui';
import { useTranslation } from 'react-i18next';

interface CustomerPortalModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CustomerPortalModal: React.FC<CustomerPortalModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const [css] = useStyletron();
  return (
    <CustomModal
      isOpen={isOpen}
      modalId="modal-customer-portal"
      onClose={() => {
        TrackerUtil.trackBtnClickByIdentifier('close', 'modal-customer-portal');
        onClose();
      }}
      additionalTestId="customer-portal"
    >
      <ModalHeader className="pe-3">
        <h3
          className={css({
            whiteSpace: 'normal',
            overflowWrap: 'break-word'
          })}
        >
          {t('customerPortalModalTitle')}
        </h3>
      </ModalHeader>
      <ModalBody>
        <CustomerPortalModalContent />
      </ModalBody>
      <CustomModalFooter>
        <Container fluid>
          <Row className="justify-content-end">
            <Col xs="auto">
              <Button
                size={SIZE.large}
                onClick={onClose}
                additionalTestId="close"
                trackClickUsingTestId={(buttonIdentifier) => {
                  TrackerUtil.trackBtnClickByIdentifier(buttonIdentifier, 'modal-customer-portal');
                }}
              >
                {t('customerPortalModalCloseButtonText')}
              </Button>
            </Col>
          </Row>
        </Container>
      </CustomModalFooter>
    </CustomModal>
  );
};

export default CustomerPortalModal;
